import { START_EDITING_COMMENT } from '../../actions/start-editing-comment';
import { categoryIds } from '../event-helpers';

const handler = ({ payload: { post, comment } }) => ({
  evid: 233,
  post_id: post._id,
  category_ids: categoryIds(post),
  comments_id: comment._id,
});

export const uouEditCommentEvent = {
  [START_EDITING_COMMENT]: handler,
};
